module.exports = __webpack_public_path__ + "69ed2488b83cefbe394f0d30f3ce3b0e.svg";